import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";

import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs/plugin/utc";
dayjs.extend(dayjsPluginUTC);

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import ShowCountSKA from "../../../aGlobalDesign/Buttons/ShowCountSKA";
import DatePicker from "../../../aGlobalDesign/DatePicker/DatePicker";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import Inputs from "../../../aGlobalDesign/Inputs/Inputs";
import Drawer from "../../../aGlobalDesign/Modal/Drawer";
import ButtonSKA from "../../../aGlobalDesign/Buttons/ButtonSKA";
import DropDown from "../../../aGlobalDesign/Inputs/Dropdown";
import SelectResourceDialog from "../../../components/Dialog/SelectResourceDialog";
import { store } from "../../../boot-client";
import Toggle from "../../../aGlobalDesign/Inputs/Toggle";

class CallCentersList extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            openModal: 0,
            selectedCallCenter: null,
            temporaryElement: null,
            forcePaginationUpdate: 0,
            isModalCallTransfersOpen: false,
            openCalendarDatesDialog: "",
            openDialogDateSelector: false,
            filesList: [],
            selectResourceDialog: null
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.CallCenters);
        this.props.ChangeCurrentMenuName("CallCenters");

        if (!this.props.administration.secondaryzones) {
            this.props.GetSecondaryZonesList();
        }
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedCallCenter: null,
            openModal: 0,
            filesList: [],
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoad(null);
        }
    }


    //#region functions
    OnDelete(id, onSuccess) {
        this.props.OpenDialog({
            title: strings.deleteConfirm,
            description: strings.textDeleteItem,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteCallCenter(id, () => {
                    this.forcePaginationUpdate();
                    this.props.GetSecondaryCallCentersList((data) => {});
                });
            }
        });
    }
    OnLoad(callcenter) {
        let d = callcenter;
        if (d === null) {
            d = {
                id: 0,
                name: "",
                description: "",
                timestamp: null,
                organizationId: this.props.currentuser.currentorganization.id,
                callCenterZones: [],
                callTransfers: [],
                portalAgentsNumber: [],
                calendar: ""
            };
        }
        else if (!d.callTransfers) {
            // if callTransfers is undefined, initialize it to array
            d.callTransfers = [];
        }
        const temp = this.CreateTemp(d);
        this.setState({
            selectedCallCenter: d,
            openModal: 1,
            filesList: [],
            temporaryElement: temp
        });
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            description: element.description,
            callCenterZones: element.callCenterZones,
            callTransfers: element.callTransfers || [],
            background: element.background,
            useBackground: element.useBackground,
            calendar: element.calendar && element.calendar !== "" ? element.calendar : JSON.stringify({ timezone: this.props.dictionaries.timezones[0], weekOpenings: [], Exceptions: [] })
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.description = temp.description;
        element.callCenterZones = temp.callCenterZones;
        element.callTransfers = temp.callTransfers;
        element.calendar = temp.calendar;
        element.background = temp.background;
        element.useBackground = temp.useBackground;
        return element;
    }
    saveSelectedCallCenter() {
        const display = this.state.selectedCallCenter;
        this.SaveTemp(this.state.temporaryElement, display);
        if ( display.name === "") {
            this.props.OpenDialog({
                description: strings.alertName,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const filesList = this.state.filesList;

        const d = {
            id: display.id,
            name: display.name,
            description: display.description,
            organizationId: this.props.currentuser.currentorganization.id,
            callCenterZones: display.callCenterZones,
            callTransfers: display.callTransfers,
            calendar: display.calendar,
            background: display.background,
            useBackground: display.useBackground,
            timestamp: display.timestamp
        };

        if (display.id === 0) {
            this.props.CreateCallCenter(filesList, d,
                (id) => {
                    this.forcePaginationUpdate();
                    this.props.GetSecondaryCallCentersList((data) => {});
                });
        }
        else {
            this.props.EditCallCenter(filesList, d,
                (updatedDisplayTimestamp) => {
                    this.forcePaginationUpdate();
                    this.props.GetSecondaryCallCentersList((data) => {});
                }
            );
        }
    }

    getDayName(daynum) {
        const homeLanguage = store.getState().home.language;
        const isFrench = homeLanguage === "fr";

        let dayName;

        // 0 is Saturday
        switch (daynum) {
            case 0:
                dayName = isFrench ? "Samedi" : "Saturday";
                break;

            case 1:
                dayName = isFrench ? "Dimanche" : "Sunday";
                break;

            case 2:
                dayName = isFrench ? "Lundi" : "Monday";
                break;

            case 3:
                dayName = isFrench ? "Mardi" : "Tuesday";
                break;

            case 4:
                dayName = isFrench ? "Mercredi" : "Wednesday";
                break;

            case 5:
                dayName = isFrench ? "Jeudi" : "Thursday";
                break;

            case 6:
                dayName = isFrench ? "Vendredi" : "Friday";
                break;

            default:
                return null;
        }

        return dayName;
    }



    getHourInput(utcvalue, period, onChange) {
        //const tdayvalue = dayjs.utc(this.state.temporaryElement.dateStartString).local().format("YYYY-MM-DD HH:mm");
        /*let value = null;
        if (utcvalue) {
            const date = new Date(dayjs.utc("2017-01-01").format("YYYY-MM-DD"));
            date.setUTCHours(Number(utcvalue.slice(0, 2)));
            date.setUTCMinutes(Number(utcvalue.slice(3, 5)));
            value = String(date.getHours()).padStart(2, "0") + ":" + String(date.getMinutes()).padStart(2, "0");
        }*/
        return (
            <input className="TextField-small-filled" type="time"
                style={{ flexGrow: "1", flexShrink: "0", fontSize: "14px", backgroundColor: "var(--input-background)" }}
                placeholder={"hh:mn"}
                disabled={this.state.preview}
                min={period && period === "am" ? "00:01" : period && period === "pm" ? "10:00" : null }
                max={period && period === "am" ? "17:00" : period && period === "pm" ? "23:59" : null }
                value={utcvalue}
                onChange={(e) => {
                /*const date = new Date(dayjs.utc("2017-01-01").format("YYYY-MM-DD"));
                date.setHours(Number(e.target.value.slice(0, 2)));
                date.setMinutes(Number(e.target.value.slice(3, 5)));
                const result = String(date.getUTCHours()).padStart(2, "0") + ":" + String(date.getUTCMinutes()).padStart(2, "0");*/
                    onChange(e.target.value);
                }}/>
        );
    }
    ConvertDateForExceptions(range) {
        if (!range) {return "";}

        // Replace space with "T" for to be have a compatibled date with ISO
        const dateStr = range.replace(" ", "T");

        const date = new Date(dateStr);

        if (isNaN(date)) {
            console.error("Invalid date:", dateStr);
            return "";
        }

        const dayOfWeek = date.toLocaleDateString("fr-FR", { weekday: "long" });
        const capitalizedDayOfWeek = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);

        const dateFormatted = date.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }).replace(/\//g, ".");

        return `${capitalizedDayOfWeek} ${dateFormatted}`;
    }

    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const calendar = this.state.temporaryElement && this.state.temporaryElement.calendar ? JSON.parse(this.state.temporaryElement.calendar) : null;
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={this.props.GetCallCentersList}
                onSavePagination={this.props.SaveCallCentersPagination}
                myElements={this.props.monitoring.callcenters}

                sortOptions={[
                    { sortName: "name", sortData: "asc" },
                    { sortName: "description", sortData: "null" },
                    { sortName: "portalAgentsNumber", sortData: "null" }
                ]}

                tableElement={(element, onReloadList) => {
                    const nbrwaitinglist = element && this.props.monitoring.callapps ? this.props.monitoring.callapps.filter(ca => ca.status === 45 && ca.callCenter.id === element.id ).length : 0;
                    return [
                        {
                            colTitle: strings.SortName,
                            sortIndex: 0,
                            fixedWidth: "300px",
                            colContent: element ? element.name : null
                        },
                        {
                            colTitle: strings.Description,
                            sortIndex: 1,
                            fixedWidth: "300px",
                            colContent: element ? element.description : null
                        },
                        {
                            colTitle: strings.SortPortalsAgent,
                            sortIndex: 2,
                            justify: "center",
                            fixedWidth: "150px",
                            lockWidth: true,
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                const value = data[column.field];
                                if (value) {
                                    return <ShowCountSKA list={value.portalAgentsNumber.map((ag) => {return " " + ag.name;})} count={value.portalAgentsNumber.length} spaceWithCount={[0, -35]}/>;
                                }
                                else {return "";}
                            },
                            colContent: element ? { portalAgentsNumber: element.portalAgentsNumber } : null
                        },
                        {
                            colTitle: strings.personsWaiting,
                            justify: "center",
                            fixedWidth: "150px",
                            lockWidth: true,
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                const value = data[column.field];
                                return value ? value.nbrwaitinglist : "";
                            },
                            colContent: element ? { nbrwaitinglist: nbrwaitinglist } : null
                        },
                        {
                            colTitle: strings.actions,
                            colType: "actions",
                            actions: [1, 2, 3],
                            colContent: [
                                <ButtonSkaRound
                                    key={"view"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(60, "consult") <= 10}
                                    onClick={() => {
                                        this.setState({ preview: true });
                                        this.OnLoad(element);
                                    }}
                                    nameIcon="eye"
                                />,
                                <ButtonSkaRound
                                    key={"edit"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(60, "modify") <= 10}
                                    onClick={() => this.OnLoad(element)}
                                    nameIcon="edit"
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(60, "delete") <= 10}
                                    onClick={() => this.OnDelete(element.id)}
                                    nameIcon="trash"
                                />
                            ]
                        }
                    ];
                }}
            />
            <Drawer open={this.state.openModal === 1}
                onClose={() => {
                    if (!this.state.preview) {
                        this.forcePaginationUpdate();
                    }
                    else {
                        this.setState({
                            selectedCallCenter: null,
                            openModal: 0,
                            temporaryElement: null,
                            preview: false
                        });
                    }
                }}
                title={this.state.preview ? strings.CallCenters : this.state.selectedCallCenter && this.state.selectedCallCenter.id !== 0 ? strings.editCallCenter : strings.CreateNewCallCenter}
                validationIcon={"save"}
                validationTitle={strings.register}

                onValidate={ !this.state.preview ? () => this.saveSelectedCallCenter() : null }
            >
                {
                    this.state.temporaryElement ?
                        <>
                            <div className="ContentTitle">{strings.Settings} </div>
                            <Inputs field={{
                                type: "textfield",
                                title: strings.name,
                                disabled: this.state.preview,
                                placeholder: strings.name,
                                error: this.state.temporaryElement.name === "",
                                value: this.state.temporaryElement.name,
                                onChange: (e) => {
                                    const dp = this.state.temporaryElement;
                                    dp.name = e.target.value;
                                    this.setState({ temporaryElement: dp });
                                }
                            }}/>
                            <Inputs field={{
                                type: "textfield",
                                title: strings.Description,
                                disabled: this.state.preview,
                                placeholder: strings.Description,
                                error: this.state.temporaryElement.description === "",
                                value: this.state.temporaryElement.description,
                                onChange: (e) => {
                                    const dp = this.state.temporaryElement;
                                    dp.description = e.target.value;
                                    this.setState({ temporaryElement: dp });
                                }
                            }}/>
                            <Inputs field={{
                                type: "togglebutton",
                                title: strings.Background,
                                width: "110px",
                                name: strings.ActivateInCall,
                                checked: this.state.temporaryElement.useBackground,
                                //disabled: !this.state.temporaryElement.useBackground,
                                disabled: this.state.preview,
                                onClick: () => {
                                    const su = { ...this.state.temporaryElement };
                                    su.useBackground = !su.useBackground;
                                    this.setState({
                                        temporaryElement: su
                                    });
                                }
                            }}/>
                            {
                                this.state.temporaryElement.useBackground ?
                                    <Inputs field={{
                                        type: "importfile",
                                        title: " 480x720 px",
                                        access: "image",
                                        value: this.state.temporaryElement.background ? JSON.parse(this.state.temporaryElement.background).PhotoName : "",
                                        thumbnail: this.state.temporaryElement.background ? JSON.parse(this.state.temporaryElement.background).PhotoThumbnailURL : "",
                                        onAddFiles: (inputFiles) => {
                                            if (inputFiles[0].size > this.props.configuration.multipartBodyLengthLimit) {
                                                this.props.OpenDialog({
                                                    title: strings.fileTooBig,
                                                    description: strings.fileTooBigDesc + this.props.configuration.multipartBodyLengthLimit / 1000000 + "MB",
                                                    primaryLabel: "OK",
                                                    clickOutsideToClose: true
                                                });
                                                this.setState({
                                                    openModal: 0
                                                });
                                                return;
                                            }

                                            //check dimensions
                                            const img = new Image();
                                            img.src = window.URL.createObjectURL(inputFiles[0]);
                                            img.onload = () => {
                                                const width = img.naturalWidth, height = img.naturalHeight;
                                                window.URL.revokeObjectURL(img.src);
                                                if (width !== 480 || height !== 720) {
                                                    this.props.OpenDialog({
                                                        title: strings.BadDimensionFile,
                                                        description: strings.TextSizeBackgroundImage,
                                                        primaryLabel: "OK",
                                                        clickOutsideToClose: true
                                                    });
                                                    this.setState({
                                                        openModal: 0
                                                    });
                                                    return;
                                                }
                                                else {
                                                    const su = { ...this.state.temporaryElement };
                                                    const filesList = this.state.filesList;
                                                    if (!filesList.some(e => e.name === inputFiles[0].name)) {
                                                        filesList.push(inputFiles[0]);
                                                    }
                                                    su.background = JSON.stringify({
                                                        PhotoName: inputFiles[0].name,
                                                        PhotoURL: inputFiles[0].name,
                                                        PhotoThumbnailURL: null
                                                    });

                                                    this.setState({
                                                        filesList: filesList,
                                                        temporaryElement: su
                                                    });
                                                }
                                            };
                                        },
                                        onOpenModal: () => {
                                            this.setState({ selectResourceDialog: "background" });
                                        }
                                    }}/> : null}
                            <Inputs field={{ type: "divider" }}/>
                            <div className="ContentTitle">{strings.managedZone} </div>
                            {
                                this.props.administration.secondaryzones ?
                                    this.props.administration.secondaryzones.results.map(zone => {
                                        return (
                                            <Inputs
                                                key={zone.id}
                                                field={{
                                                    type: "squareradiobuttons",
                                                    name: zone.name,
                                                    disabled: this.state.preview,
                                                    elements: [
                                                        {
                                                            name: zone.name,
                                                            disabled: this.state.preview,
                                                            checked: (this.state.temporaryElement.callCenterZones || []).some(
                                                                (ccz) => ccz.zoneId === zone.id
                                                            ),
                                                            onClick: () => {
                                                                const updatedCallCenterZones = [...this.state.temporaryElement.callCenterZones || []];

                                                                const existingIndexZone = updatedCallCenterZones.findIndex(
                                                                    (ccz) => ccz.zoneId === zone.id
                                                                );

                                                                if (existingIndexZone >= 0) {
                                                                    updatedCallCenterZones.splice(existingIndexZone, 1);
                                                                }
                                                                else {
                                                                    updatedCallCenterZones.push({ id: -1, callCenterId: -1, zoneId: zone.id });
                                                                }

                                                                this.setState(prevState => ({
                                                                    temporaryElement: {
                                                                        ...prevState.temporaryElement,
                                                                        callCenterZones: updatedCallCenterZones
                                                                    }
                                                                }));
                                                            }
                                                        }
                                                    ]
                                                }}/>
                                        );
                                    })
                                    :
                                    []
                            }
                            <Inputs field={{ type: "divider" }}/>
                            <div className="ContentTitle">{strings.callTransfersTo} </div>
                            {
                                this.props.monitoring.callcenters
                                    ? this.props.monitoring.callcenters.results.map((callCenter) => {
                                        return (
                                            <Inputs
                                                key={callCenter.id}
                                                field={{
                                                    type: "squareradiobuttons",
                                                    name: callCenter.name,
                                                    disabled: this.state.preview,
                                                    elements: [
                                                        {
                                                            name: callCenter.name,
                                                            disabled: this.state.preview,
                                                            checked: (this.state.temporaryElement.callTransfers || []).some(
                                                                (cc) => cc.callCenterToId === callCenter.id
                                                            ),
                                                            onClick: () => {
                                                                const dp = this.state.temporaryElement.callTransfers || [];

                                                                const existingIndexCallCenter = dp.findIndex((cc) => cc.callCenterToId === callCenter.id);

                                                                if (existingIndexCallCenter >= 0) {
                                                                    dp.splice(existingIndexCallCenter, 1);
                                                                }
                                                                else {
                                                                    dp.push({ callCenterToId: callCenter.id });
                                                                }

                                                                this.setState(prevState => ({
                                                                    temporaryElement: {
                                                                        ...prevState.temporaryElement,
                                                                        callTransfers: dp
                                                                    }
                                                                }));
                                                            }
                                                        }
                                                    ]
                                                }}/>
                                        );
                                    })
                                    : []
                            }
                            <Inputs field={{ type: "divider" }}/>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", alignItems: "center" }}>
                                <div className="ContentTitle" style={{ width: "auto" }}>{strings.openHour}</div>
                                <DropDown
                                    preventEmpty={true}
                                    disabled={this.state.preview}
                                    list={this.props.dictionaries.timezones ? this.props.dictionaries.timezones : []}
                                    value={calendar && calendar.timezone ? calendar.timezone.id : null}
                                    onChange={(newtz) => {
                                        const updatedCalendar = { ...calendar };
                                        updatedCalendar.weekOpenings.forEach((wo, oIndex) => {
                                            wo = { ...wo,
                                                amstart: "08:00",
                                                amend: "12:00",
                                                pmstart: "14:00",
                                                pmend: "18:00"
                                            };
                                        });
                                        this.setState(prevState => ({
                                            temporaryElement: {
                                                ...prevState.temporaryElement,
                                                calendar: JSON.stringify({ ...updatedCalendar, timezone: newtz })
                                            }
                                        }));
                                    }}
                                />
                            </div>
                            {
                                [2, 3, 4, 5, 6, 0, 1].map((daynum) => {
                                    const oIndex = calendar.weekOpenings.findIndex(d => d.daynum === daynum);
                                    return <React.Fragment key={daynum}>
                                        <div style={{ border: "1px solid var(--grey-base)", borderRadius: "6px", padding: "20px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", gap: "12px" }}>
                                                <div className="ContentName" style={{ fontWeight: "700", width: "90px", fontSize: "22px" }}>
                                                    {this.getDayName(daynum)}
                                                </div>
                                                <span style={{ display: "flex", flexGrow: 1 }}/>
                                                { oIndex >= 0 ?
                                                    <Toggle
                                                        type="switch"
                                                        disabled={this.state.preview}
                                                        name={"Ouvert toute la journée"}
                                                        checked={oIndex >= 0 && calendar.weekOpenings[oIndex].alwaysopen}
                                                        onClick={() => {
                                                            const updatedCalendar = { ...calendar };
                                                            if (oIndex >= 0) {
                                                                updatedCalendar.weekOpenings[oIndex].alwaysopen = !updatedCalendar.weekOpenings[oIndex].alwaysopen;
                                                            }
                                                            this.setState(prevState => ({
                                                                temporaryElement: {
                                                                    ...prevState.temporaryElement,
                                                                    calendar: JSON.stringify(updatedCalendar)
                                                                }
                                                            }));
                                                        }}
                                                    /> : null
                                                }
                                                <Toggle
                                                    type="switch"
                                                    disabled={this.state.preview}
                                                    name={strings.Activate}
                                                    checked={oIndex >= 0}
                                                    onClick={() => {
                                                        const updatedCalendar = { ...calendar };
                                                        if (oIndex >= 0) {
                                                            updatedCalendar.weekOpenings.splice(oIndex, 1);
                                                        }
                                                        else {
                                                            updatedCalendar.weekOpenings.push({
                                                                daynum: daynum,
                                                                alwaysopen: true,
                                                                amstart: "08:00",
                                                                amend: "12:00",
                                                                pmstart: "14:00",
                                                                pmend: "18:00"
                                                            });
                                                        }
                                                        this.setState(prevState => ({
                                                            temporaryElement: {
                                                                ...prevState.temporaryElement,
                                                                calendar: JSON.stringify(updatedCalendar)
                                                            }
                                                        }));
                                                    }}
                                                />
                                            </div>
                                            {
                                                oIndex >= 0 && !calendar.weekOpenings[oIndex].alwaysopen ? <>
                                                    <span style={{ display: "block", height: "20px" }}></span>
                                                    <div className={"horizontalFlexContainer"} style={{ gap: "10px" }}>
                                                        <div className="ContentName" style={{ fontWeight: "400", width: "140px" }}>{strings.Morning}</div>
                                                        {this.getHourInput(
                                                            calendar.weekOpenings[oIndex].amstart,
                                                            "am",
                                                            (e) => {
                                                                const updatedCalendar = JSON.parse(JSON.stringify(calendar));
                                                                updatedCalendar.weekOpenings[oIndex].amstart = e;
                                                                this.setState(prevState => ({
                                                                    temporaryElement: {
                                                                        ...prevState.temporaryElement,
                                                                        calendar: JSON.stringify(updatedCalendar)
                                                                    }
                                                                }));
                                                            }
                                                        )}
                                                        {strings.toHour}
                                                        {this.getHourInput(
                                                            calendar.weekOpenings[oIndex].amend,
                                                            "am",
                                                            (e) => {
                                                                const updatedCalendar = JSON.parse(JSON.stringify(calendar));
                                                                updatedCalendar.weekOpenings[oIndex].amend = e;
                                                                this.setState(prevState => ({
                                                                    temporaryElement: {
                                                                        ...prevState.temporaryElement,
                                                                        calendar: JSON.stringify(updatedCalendar)
                                                                    }
                                                                }));
                                                            }
                                                        )}
                                                    </div>
                                                    <span style={{ display: "block", height: "20px" }}></span>
                                                    <div className={"horizontalFlexContainer"} style={{ gap: "10px" }}>
                                                        <div className="ContentName" style={{ fontWeight: "400", width: "140px" }}>{strings.Afternoon}</div>
                                                        {this.getHourInput(
                                                            calendar.weekOpenings[oIndex].pmstart,
                                                            "pm",
                                                            (e) => {
                                                                const updatedCalendar = JSON.parse(JSON.stringify(calendar));
                                                                updatedCalendar.weekOpenings[oIndex].pmstart = e;
                                                                this.setState(prevState => ({
                                                                    temporaryElement: {
                                                                        ...prevState.temporaryElement,
                                                                        calendar: JSON.stringify(updatedCalendar)
                                                                    }
                                                                }));
                                                            }
                                                        )}
                                                        {strings.toHour}
                                                        {this.getHourInput(
                                                            calendar.weekOpenings[oIndex].pmend,
                                                            "pm",
                                                            (e) => {
                                                                const updatedCalendar = JSON.parse(JSON.stringify(calendar));
                                                                updatedCalendar.weekOpenings[oIndex].pmend = e;
                                                                this.setState(prevState => ({
                                                                    temporaryElement: {
                                                                        ...prevState.temporaryElement,
                                                                        calendar: JSON.stringify(updatedCalendar)
                                                                    }
                                                                }));
                                                            }
                                                        )}
                                                    </div>
                                                </> : null
                                            }
                                        </div>
                                    </React.Fragment>;
                                })
                            }
                            <Inputs field={{ type: "divider" }}/>
                            <div className="ContentTitle" style={{ alignItems: "center", justifyContent: "space-between" }}>
                                {strings.exceptionClose}
                                <ButtonSKA
                                    type="primary-icon"
                                    isDisabled={this.state.preview}
                                    onClick={() => {
                                        this.setState({ openDialogDateSelector: true });
                                    }}
                                    nameIcon="add"
                                    text={strings.addDate}
                                />
                            </div>
                            {
                                this.state.temporaryElement && this.state.temporaryElement.calendar !== null && this.state.temporaryElement.calendar !== undefined && this.state.temporaryElement.calendar !== "" ?

                                    JSON.parse(this.state.temporaryElement.calendar).Exceptions.map((range, index) => {

                                        return (
                                            <div key={index} className={"horizontalFlexContainer"}
                                                style={{
                                                    gap: "10px", justifyContent: "space-between",
                                                    borderRadius: "10px", padding: "10px 20px",
                                                    width: "calc(100% - 40px)",
                                                    border: "1px solid var(--grey-light)",
                                                    background: "var(--grey-lighter)"
                                                }}
                                            >
                                                {this.ConvertDateForExceptions(range.startDate) + " > " + this.ConvertDateForExceptions(range.endDate)}
                                                <ButtonSkaRound
                                                    type="secondary"
                                                    isDisabled={this.state.preview}
                                                    onClick={() => {
                                                        const temp = this.state.temporaryElement.calendar;
                                                        const calendar = JSON.parse(temp);
                                                        calendar.Exceptions.splice(index, 1);
                                                        this.setState(prevState => ({
                                                            temporaryElement: {
                                                                ...prevState.temporaryElement,
                                                                calendar: JSON.stringify(calendar)
                                                            }
                                                        }));
                                                    }}
                                                    nameIcon="trash"
                                                />
                                            </div>
                                        );
                                    })

                                    :
                                    null
                            }
                        </> : null
                }
            </Drawer>
            <>
                { this.state.selectResourceDialog ?
                    <SelectResourceDialog open={this.state.selectResourceDialog !== null}
                        icon="qrcode"
                        title={strings.selectContent}
                        onClose={() => this.setState({ selectResourceDialog: null })}
                        onSelect={ (element) => {
                            const su = { ...this.state.temporaryElement };
                            if (element.contentTypeId === 20) {
                                //check dimensions
                                const img = new Image();
                                const eldata = JSON.parse(element.data);
                                img.src = eldata.Uri;
                                img.onload = () => {
                                    const width = img.naturalWidth, height = img.naturalHeight;
                                    if (width !== 480 || height !== 720) {
                                        this.props.OpenDialog({
                                            title: strings.BadDimensionFile,
                                            description: strings.TextSizeBackgroundImage,
                                            primaryLabel: "OK",
                                            clickOutsideToClose: true
                                        });
                                        this.setState({
                                            openModal: 0,
                                            selectResourceDialog: null
                                        });
                                        return;
                                    }
                                    else {
                                        su.background = JSON.stringify({
                                            PhotoName: element.name,
                                            PhotoURL: eldata.Uri,
                                            PhotoThumbnailURL: eldata.ThumbnailUri
                                        });
                                        this.setState({
                                            temporaryElement: su,
                                            selectResourceDialog: null
                                        });
                                    }
                                };
                            }

                        }}/> : null
                }
                <DatePicker open={this.state.openDialogDateSelector}
                    title={strings.closingDay}
                    onClose={() => this.setState({ openDialogDateSelector: false })}
                    onValidate={(range) => {
                        let calendar;

                        if (!this.state.temporaryElement.calendar) {
                            calendar = { weekOpenings: [], Exceptions: [] };
                        }
                        else {
                            try {
                                calendar = JSON.parse(this.state.temporaryElement.calendar);
                            }
                            catch (error) {
                                console.error("Error when parse calendar:", error);
                                return;
                            }
                        }

                        calendar.Exceptions.push({ startDate: range.startDate, endDate: range.endDate ? range.endDate : range.startDate });

                        const updatedCalendar = JSON.stringify(calendar);

                        this.setState(prevState => ({
                            temporaryElement: {
                                ...prevState.temporaryElement,
                                calendar: updatedCalendar
                            },
                            openDialogDateSelector: false
                        }));
                    }}
                />
            </>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(CallCentersList);
